var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',[_vm._v("Data Fixer")]),_c('v-tab',[_vm._v("Data Eraser")]),_c('v-tab-item',[_c('Fixer')],1),_c('v-tab-item',[_c('Eraser')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }